import { connect } from 'react-redux';
import { logOut, selectSessionUser } from '@zippeditoolsjs/heimdal-react';
import MyMenu from '../../../components/navbar/MyMenu';

export default connect(
  state => ({
    // The selector answers null for a visitor with no session; the guard only
    // mounts this menu once there is one, so the fallback is a guard rail.
    userInfo: selectSessionUser(state) || {},
  }),
  { logOut },
)(MyMenu);
